import { render, staticRenderFns } from "./ReceptionExpiredCards.vue?vue&type=template&id=2afd5f8d&scoped=true"
import script from "./ReceptionExpiredCards.vue?vue&type=script&lang=js"
export * from "./ReceptionExpiredCards.vue?vue&type=script&lang=js"
import style0 from "./ReceptionExpiredCards.vue?vue&type=style&index=0&id=2afd5f8d&prod&lang=scss&scoped=true"
import style1 from "./ReceptionExpiredCards.vue?vue&type=style&index=1&id=2afd5f8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd5f8d",
  null
  
)

export default component.exports